/**
 * AllergyFilterBanner — non-dismissable correction banner (Plan 05-08a).
 *
 * Renders ABOVE the corrected assistant bubble when the server-side allergy
 * filter fires. Background bg-ai-filter-bg (ochre-soft); non-dismissable
 * (permanent audit trail per AI-12).
 *
 * UI-SPEC §Component 5.
 *
 * #158 (steg 8a): banneret er ikke tegnet i skissen og beholdes som det er,
 * restylet med tokenene: amber flate (`ai-filter-*` = warn-tokenene, D3) med
 * radius 16 og samme bredde som assistentboblen. Teksten er ink, som i
 * allergibanneret på Handle, og skjoldet er warn. Begge parene står i
 * contrast.test.ts (rett på lerretet og i gløden).
 *
 * Aria: role="note" aria-label="Allergijustering" — screen reader announces
 *       before the corrected message.
 *
 * data-testid: assistant-allergy-filter-banner
 */
import { useTranslation } from 'react-i18next';
import { Icon } from '../../components/primitives';

export function AllergyFilterBanner() {
  const { t } = useTranslation();

  return (
    <div
      data-testid="assistant-allergy-filter-banner"
      role="note"
      aria-label={t('assistant.allergy_filter.aria')}
      className="my-2 mr-auto flex max-w-22/25 items-center gap-2.5 rounded-md border border-ai-filter-border bg-ai-filter-bg px-4 py-3 text-ink"
    >
      <Icon.AlertShield size={18} className="shrink-0 text-ai-filter-fg" />
      <span className="text-base font-semibold">{t('assistant.allergy_filter.notice')}</span>
    </div>
  );
}
